import { defineComponent, ref, computed, reactive, watch, onMounted } from 'vue-demi';
import { OrMenuV3, OrMenuItemV3, OrIconV3, OrIconButtonV3, useResponsive, getAbbreviation, generateColorFromString, OrSkeletonTextV3, OrSkeletonRectV3, OrSwitchV3, OrCheckboxV3, OrFilterV3, OrInputV3, OrEmptyStateV3, OrButtonV3, OrPopoverV3, OrDrawerV3 } from '@onereach/ui-components';
import { useElementHover, useMounted, useToggle, useElementBounding } from '@vueuse/core';
import './useAccountSettings-bcd0cc43.js';
import '@or-sdk/notifications';
import 'lodash/orderBy';
import 'lodash/uniqBy';
import { u as useI18n } from './useI18n-25380ee3.js';
import _ from 'lodash';
import { twMerge } from 'tailwind-merge';
import { resolveComponent, openBlock, createBlock, withCtx, createTextVNode, toDisplayString, createCommentVNode, createElementBlock, normalizeClass, createElementVNode, normalizeStyle, withModifiers, createVNode, Fragment, renderList } from 'vue';

var UserRoles;
(function (UserRoles) {
  UserRoles["guest"] = "GUEST";
  UserRoles["readOnly"] = "READONLY";
  UserRoles["user"] = "USER";
  UserRoles["admin"] = "ADMIN";
  UserRoles["superAdmin"] = "SUPER_ADMIN";
})(UserRoles || (UserRoles = {}));

function isAllowed(lvl, role) {
  if (lvl === 'environment') {
    return role === UserRoles.superAdmin;
  }
  if (lvl === 'account') {
    return role === UserRoles.admin || role === UserRoles.superAdmin;
  }
  return true;
}

var script$6 = defineComponent({
  name: 'ServiceNaviagtionDropdownPopoverItemMenu',
  components: {
    OrMenuV3,
    OrMenuItemV3
  },
  props: {
    userRole: {
      type: String,
      required: true
    },
    trigger: {
      type: Object,
      default: null
    },
    item: {
      type: Object,
      required: true
    }
  },
  expose: ['toggle', 'state'],
  emits: ['hideFromAccount', 'hideFromEnvironment', 'revealOnAccount', 'revealOnEnvironment', 'delete'],
  setup() {
    const menu = ref();
    const {
      t
    } = useI18n();
    const state = computed(() => {
      var _a;
      return (_a = menu.value) === null || _a === void 0 ? void 0 : _a.state;
    });
    function toggle() {
      var _a;
      (_a = menu.value) === null || _a === void 0 ? void 0 : _a.toggle();
    }
    return {
      t,
      toggle,
      isAllowed,
      menu,
      state
    };
  }
});

function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrMenuItemV3 = resolveComponent("OrMenuItemV3");
  const _component_OrMenuV3 = resolveComponent("OrMenuV3");
  return openBlock(), createBlock(_component_OrMenuV3, {
    ref: "menu",
    trigger: _ctx.trigger
  }, {
    default: withCtx(() => [_ctx.isAllowed('account', _ctx.userRole) && !_ctx.item.hiddenFromAccount ? (openBlock(), createBlock(_component_OrMenuItemV3, {
      key: 0,
      icon: "visibility_off",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('hideFromAccount'))
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.t('serviceDropdown.Hide from account')), 1 /* TEXT */)]),

      _: 1 /* STABLE */
    })) : createCommentVNode("v-if", true), _ctx.isAllowed('account', _ctx.userRole) && _ctx.item.hiddenFromAccount ? (openBlock(), createBlock(_component_OrMenuItemV3, {
      key: 1,
      icon: "visibility",
      onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('revealOnAccount'))
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.t('serviceDropdown.Show in account')), 1 /* TEXT */)]),

      _: 1 /* STABLE */
    })) : createCommentVNode("v-if", true), _ctx.isAllowed('environment', _ctx.userRole) && !_ctx.item.hiddenFromEnvironment ? (openBlock(), createBlock(_component_OrMenuItemV3, {
      key: 2,
      icon: "visibility_off",
      onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('hideFromEnvironment'))
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.t('serviceDropdown.Hide from environment')), 1 /* TEXT */)]),

      _: 1 /* STABLE */
    })) : createCommentVNode("v-if", true), _ctx.isAllowed('environment', _ctx.userRole) && _ctx.item.hiddenFromEnvironment ? (openBlock(), createBlock(_component_OrMenuItemV3, {
      key: 3,
      icon: "visibility",
      onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('revealOnEnvironment'))
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.t('serviceDropdown.Show in environment')), 1 /* TEXT */)]),

      _: 1 /* STABLE */
    })) : createCommentVNode("v-if", true), _ctx.isAllowed('environment', _ctx.userRole) ? (openBlock(), createBlock(_component_OrMenuItemV3, {
      key: 4,
      icon: "delete",
      class: "border-t-1 border-solid border-outline-variant dark:border-outline-variant-dark",
      onClick: _cache[4] || (_cache[4] = $event => _ctx.$emit('delete'))
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.t('serviceDropdown.Delete')), 1 /* TEXT */)]),

      _: 1 /* STABLE */
    })) : createCommentVNode("v-if", true)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["trigger"]);
}

script$6.render = render$6;
script$6.__file = "src/components/ServiceNavigationDropdown/ServiceNavigationDropdownPopoverItemMenu.vue";

const itemRoot = ['layout-row', 'relative', 'cursor-pointer', 'px-lg py-sm+ md:p-sm gap-md md:gap-sm+ rounded-md', 'hover:bg-primary-opacity-0-08 dark:hover:bg-primary-opacity-0-08-dark', 'selected:!bg-primary-opacity-0-12 dark:selected:hover:!bg-primary-opacity-0-12-dark'];
const itemHidden = ['border-dashed md:border-1 border-on-disabled dark:border-on-disabled-dark'];
const itemImage = ['flex', 'relative', 'shrink-0', 'items-center', 'h-[32px] w-[32px]', 'md:h-[64px] md:w-[64px]', 'typography-body-2-bold', 'md:typography-headline-1 dark:text-inverse-on-surface-dark', 'text-on-primary', 'rounded-md', 'justify-center'];
const itemImageHidden = ['!bg-disabled dark:!bg-disabled-dark'];
const itemServiceLabel = ['grow', 'sm:w-[118px]', 'typography-body-2-regular', 'selected:typography-body-2-bold', 'text-on-background dark:text-on-background-dark'];
const itemServiceLabelHidden = ['text-on-disabled dark:text-on-disabled-dark'];
const superAdminMenuTrigger = ['absolute', 'right-lg md:right-sm top-md md:top-sm', 'rounded-sm', 'hover:bg-white dark:hover:bg-black', '!outline-transparent'];
const adminMenuTrigger = ['absolute', 'right-lg md:right-sm top-md md:top-sm', 'rounded-sm', 'bg-white dark:bg-black', '!outline-transparent'];

var script$5 = defineComponent({
  name: 'ServiceNavigationDropdownPopoverItem',
  components: {
    OrIconV3,
    OrIconButtonV3,
    ServiceNavigationDropdownPopoverItemMenu: script$6
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    favorite: {
      type: Boolean,
      default: false
    },
    currentServiceId: {
      type: String,
      default: ''
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    userRole: {
      type: String,
      required: true
    }
  },
  emits: ['toggleFavorite', 'delete', 'hideFromAccount', 'hideFromEnvironment', 'revealOnAccount', 'revealOnEnvironment'],
  setup(props, {
    emit
  }) {
    const link = ref();
    const menuButton = ref();
    const menu = ref();
    const imgError = ref(false);
    const {
      t
    } = useI18n();
    const isHovered = useElementHover(link);
    const {
      isMobile
    } = useResponsive();
    const translatedLabel = computed(() => t(props.item.label));
    const abbr = computed(() => getAbbreviation(translatedLabel.value));
    const isHidden = computed(() => props.item.hiddenFromAccount || props.item.hiddenFromEnvironment);
    const selected = computed(() => _.kebabCase(props.item.id) === _.kebabCase(props.currentServiceId));
    const menuOpen = computed(() => {
      var _a;
      return ((_a = menu.value) === null || _a === void 0 ? void 0 : _a.state) === 'open';
    });
    const showSuperAdminMenu = computed(() => {
      if (props.userRole !== UserRoles.superAdmin) return false;
      return props.isEditing && isHovered.value || props.isEditing && isMobile.value || menuOpen.value;
    });
    const showAdminMenu = computed(() => {
      if (props.userRole !== UserRoles.admin) return false;
      return props.isEditing && isHovered.value || props.isEditing && isMobile.value || menuOpen.value;
    });
    const color = computed(() => {
      return isHidden.value ? 'transparent' : generateColorFromString(props.item.label);
    });
    const rootStyles = computed(() => [...itemRoot, ...(isHidden.value ? itemHidden : [])]);
    const itemImageStyles = computed(() => [...itemImage, ...(isHidden.value ? itemImageHidden : [])]);
    const labelStyles = computed(() => twMerge(...itemServiceLabel, ...(isHidden.value ? itemServiceLabelHidden : [])));
    const superAdminMenuTrigger$1 = computed(() => twMerge(...superAdminMenuTrigger));
    const adminMenuTrigger$1 = computed(() => twMerge(...adminMenuTrigger));
    function handleStarClick() {
      emit('toggleFavorite', props.item.id);
    }
    function setAltImg() {
      imgError.value = true;
    }
    return {
      t,
      translatedLabel,
      abbr,
      color,
      link,
      menuButton,
      menu,
      isHovered,
      imgError,
      menuOpen,
      showSuperAdminMenu,
      showAdminMenu,
      handleStarClick,
      setAltImg,
      selected,
      isMobile,
      rootStyles,
      itemImageStyles,
      labelStyles,
      superAdminMenuTrigger: superAdminMenuTrigger$1,
      adminMenuTrigger: adminMenuTrigger$1
    };
  }
});

const _hoisted_1$4 = ["href", "selected", "force-state"];
const _hoisted_2$4 = {
  key: 0
};
const _hoisted_3$3 = ["src"];
const _hoisted_4$3 = {
  key: 1
};
const _hoisted_5$2 = ["selected"];
const _hoisted_6$2 = {
  class: "ml-auto"
};
function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIconV3 = resolveComponent("OrIconV3");
  const _component_OrIconButtonV3 = resolveComponent("OrIconButtonV3");
  const _component_or_icon_button_v3 = resolveComponent("or-icon-button-v3");
  const _component_ServiceNavigationDropdownPopoverItemMenu = resolveComponent("ServiceNavigationDropdownPopoverItemMenu");
  return openBlock(), createElementBlock("a", {
    ref: "link",
    class: normalizeClass(_ctx.rootStyles),
    href: !_ctx.isEditing ? _ctx.item.url : undefined,
    selected: _ctx.selected,
    "force-state": _ctx.menuOpen ? 'hover' : undefined
  }, [createElementVNode("div", {
    style: normalizeStyle({
      backgroundColor: _ctx.color
    }),
    class: normalizeClass(_ctx.itemImageStyles)
  }, [_ctx.item.logo && !_ctx.imgError ? (openBlock(), createElementBlock("div", _hoisted_2$4, [createElementVNode("img", {
    src: _ctx.item.logo,
    onError: _cache[0] || (_cache[0] = (...args) => _ctx.setAltImg && _ctx.setAltImg(...args))
  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_3$3)])) : (openBlock(), createElementBlock("div", _hoisted_4$3, toDisplayString(_ctx.abbr), 1 /* TEXT */)), !_ctx.isMobile && (_ctx.favorite || _ctx.isHovered) && !_ctx.isEditing ? (openBlock(), createBlock(_component_OrIconV3, {
    key: 2,
    icon: "star",
    variant: _ctx.favorite ? 'filled' : 'outlined',
    class: "absolute right-xs top-xs",
    onClick: withModifiers(_ctx.handleStarClick, ["prevent"])
  }, null, 8 /* PROPS */, ["variant", "onClick"])) : createCommentVNode("v-if", true)], 6 /* CLASS, STYLE */), createElementVNode("div", {
    class: normalizeClass(_ctx.labelStyles),
    selected: _ctx.selected
  }, toDisplayString(_ctx.translatedLabel), 11 /* TEXT, CLASS, PROPS */, _hoisted_5$2), createElementVNode("div", _hoisted_6$2, [_ctx.isMobile && !_ctx.isEditing ? (openBlock(), createBlock(_component_OrIconButtonV3, {
    key: 0,
    class: "text-on-background dark:text-on-background-dark",
    icon: {
      icon: 'star',
      variant: _ctx.favorite ? 'filled' : 'outlined'
    },
    size: "l",
    onClick: withModifiers(_ctx.handleStarClick, ["prevent"])
  }, null, 8 /* PROPS */, ["icon", "onClick"])) : createCommentVNode("v-if", true)]), _ctx.showAdminMenu ? (openBlock(), createBlock(_component_or_icon_button_v3, {
    key: 0,
    class: normalizeClass(_ctx.adminMenuTrigger),
    size: "l",
    icon: _ctx.item.hiddenFromAccount ? 'visibility' : 'visibility_off',
    tooltip: {
      content: _ctx.item.hiddenFromAccount ? _ctx.t('serviceDropdown.Show in account') : _ctx.t('serviceDropdown.Hide from account'),
      placement: 'top'
    },
    onClick: _cache[1] || (_cache[1] = withModifiers($event => _ctx.item.hiddenFromAccount ? _ctx.$emit('revealOnAccount', _ctx.item.id) : _ctx.$emit('hideFromAccount', _ctx.item.id), ["prevent"]))
  }, null, 8 /* PROPS */, ["class", "icon", "tooltip"])) : createCommentVNode("v-if", true), _ctx.showSuperAdminMenu ? (openBlock(), createBlock(_component_OrIconButtonV3, {
    key: 1,
    ref: "menuButton",
    class: normalizeClass(_ctx.superAdminMenuTrigger),
    size: "l",
    icon: "more_vert",
    "force-state": _ctx.menuOpen ? 'hover' : undefined,
    onClick: _cache[2] || (_cache[2] = withModifiers($event => _ctx.menu && _ctx.menu.toggle(), ["prevent"]))
  }, null, 8 /* PROPS */, ["class", "force-state"])) : createCommentVNode("v-if", true), createVNode(_component_ServiceNavigationDropdownPopoverItemMenu, {
    ref: "menu",
    trigger: _ctx.menuButton && _ctx.menuButton.root,
    "user-role": _ctx.userRole,
    item: _ctx.item,
    onHideFromEnvironment: _cache[3] || (_cache[3] = $event => _ctx.$emit('hideFromEnvironment', _ctx.item.id)),
    onHideFromAccount: _cache[4] || (_cache[4] = $event => _ctx.$emit('hideFromAccount', _ctx.item.id)),
    onRevealOnEnvironment: _cache[5] || (_cache[5] = $event => _ctx.$emit('revealOnEnvironment', _ctx.item.id)),
    onRevealOnAccount: _cache[6] || (_cache[6] = $event => _ctx.$emit('revealOnAccount', _ctx.item.id)),
    onDelete: _cache[7] || (_cache[7] = $event => _ctx.$emit('delete', _ctx.item.id))
  }, null, 8 /* PROPS */, ["trigger", "user-role", "item"])], 10 /* CLASS, PROPS */, _hoisted_1$4);
}

script$5.render = render$5;
script$5.__file = "src/components/ServiceNavigationDropdown/ServiceNavigationDropdownPopoverItem.vue";

var script$4 = defineComponent({
  name: 'ServiceNaviagtionDropdownPopoverItem',
  components: {
    OrSkeletonTextV3,
    OrSkeletonRectV3
  },
  setup() {
    return {
      itemRoot
    };
  }
});

function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrSkeletonRectV3 = resolveComponent("OrSkeletonRectV3");
  const _component_OrSkeletonTextV3 = resolveComponent("OrSkeletonTextV3");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.itemRoot)
  }, [createVNode(_component_OrSkeletonRectV3, {
    width: 64,
    height: 64,
    class: "shrink-0"
  }), createVNode(_component_OrSkeletonTextV3, {
    "font-size": 16
  })], 2 /* CLASS */);
}

script$4.render = render$4;
script$4.__file = "src/components/ServiceNavigationDropdown/ServiceNavigationDropdownPopoverItemSkeleton.vue";

var script$3 = defineComponent({
  name: 'ServiceNavigationDropdownIdwSection',
  components: {
    OrIcon: OrIconV3
  },
  props: {
    idwInfo: {
      type: Object,
      default: () => undefined
    }
  },
  setup(props) {
    const {
      isDesktop
    } = useResponsive();
    const {
      t
    } = useI18n();
    const OnClick = () => {
      var _a;
      ((_a = props.idwInfo) === null || _a === void 0 ? void 0 : _a.serviceLink) ? window.location.href = props.idwInfo.serviceLink : void 0;
    };
    return {
      t,
      isDesktop,
      OnClick
    };
  }
});

const _hoisted_1$3 = {
  ref: "root",
  class: "layout-column w-full max-w-[1078px]"
};
const _hoisted_2$3 = {
  class: "typography-body-2-regular px-sm pb-sm"
};
const _hoisted_3$2 = ["href"];
const _hoisted_4$2 = {
  class: "flex items-center justify-between p-sm"
};
const _hoisted_5$1 = {
  class: "typography-display-small overflow-hidden text-ellipsis text-on-background dark:text-on-background-dark"
};
const _hoisted_6$1 = /*#__PURE__*/createElementVNode("div", {
  class: "mx-sm h-[1px] bg-outline-variant-dark"
}, null, -1 /* HOISTED */);

function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIcon = resolveComponent("OrIcon");
  return openBlock(), createElementBlock("div", _hoisted_1$3, [createElementVNode("div", _hoisted_2$3, toDisplayString(_ctx.t('idw')), 1 /* TEXT */), createElementVNode("div", {
    class: normalizeClass(["flex-col", {
      'pb-md': _ctx.isDesktop
    }])
  }, [createElementVNode("a", {
    class: "flex w-full flex-col rounded-lg text-outline hover:bg-primary-opacity-0-12 hover:text-on-background dark:text-outline-dark dark:hover:bg-primary-opacity-0-08-dark dark:hover:text-on-background-dark",
    href: _ctx.idwInfo.serviceLink
  }, [createElementVNode("div", _hoisted_4$2, [createElementVNode("span", _hoisted_5$1, toDisplayString(_ctx.idwInfo.name), 1 /* TEXT */), createVNode(_component_OrIcon, {
    icon: "navigate_next",
    variant: "outlined"
  })]), _hoisted_6$1], 8 /* PROPS */, _hoisted_3$2)], 2 /* CLASS */)], 512 /* NEED_PATCH */);
}

script$3.render = render$3;
script$3.__file = "src/components/ServiceNavigationDropdown/ServiceNavigationDropdownIdwSection.vue";

var script$2 = defineComponent({
  name: 'ServiceNavigationDropdownEdit',
  components: {
    OrSwitchV3,
    OrCheckboxV3,
    OrFilterV3
  },
  props: {
    isEditing: {
      type: Boolean,
      default: false
    },
    userRole: {
      type: String,
      default: undefined
    }
  },
  emits: ['update:isEditing', 'update:filterState'],
  setup(props, {
    emit
  }) {
    const filterRef = ref();
    const activated = ref(props.isEditing);
    const state = reactive({
      visible: false,
      hiddenOnEnvironment: false,
      hiddenOnAccount: false
    });
    const mobileState = reactive({
      visible: false,
      hiddenOnEnvironment: false,
      hiddenOnAccount: false
    });
    const {
      t
    } = useI18n();
    const {
      isMobile
    } = useResponsive();
    const filterTriggerProps = computed(() => {
      return {
        icon: 'filter',
        label: t('serviceDropdown.Filters'),
        active: activated.value,
        value: Object.values(mobileState).reduce((a, item) => a + (item ? 1 : 0), 0)
      };
    });
    const isEnvManager = computed(() => props.userRole && isAllowed('environment', props.userRole));
    watch(activated, value => {
      emit('update:isEditing', value);
    });
    watch(state, () => {
      emit('update:filterState', state);
    });
    function handleReset() {
      var _a;
      state.visible = mobileState.visible = false;
      state.hiddenOnEnvironment = mobileState.hiddenOnEnvironment = false;
      state.hiddenOnAccount = mobileState.hiddenOnAccount = false;
      (_a = filterRef.value) === null || _a === void 0 ? void 0 : _a.close();
    }
    function handleApply() {
      var _a;
      state.visible = mobileState.visible;
      state.hiddenOnEnvironment = mobileState.hiddenOnEnvironment;
      state.hiddenOnAccount = mobileState.hiddenOnAccount;
      (_a = filterRef.value) === null || _a === void 0 ? void 0 : _a.close();
    }
    return {
      activated,
      state,
      mobileState,
      isEnvManager,
      t,
      handleReset,
      handleApply,
      filterTriggerProps,
      isMobile,
      filterRef
    };
  }
});

const _hoisted_1$2 = {
  class: "layout-row min-h-[45px] justify-between md:min-h-[auto]"
};
const _hoisted_2$2 = {
  key: 0
};
const _hoisted_3$1 = {
  key: 0,
  class: "layout-row gap-md"
};
const _hoisted_4$1 = {
  class: ""
};
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrSwitchV3 = resolveComponent("OrSwitchV3");
  const _component_OrCheckboxV3 = resolveComponent("OrCheckboxV3");
  const _component_OrFilterV3 = resolveComponent("OrFilterV3");
  return openBlock(), createElementBlock("div", _hoisted_1$2, [createVNode(_component_OrSwitchV3, {
    modelValue: _ctx.activated,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.activated = $event),
    label: _ctx.t('serviceDropdown.Edit mode')
  }, null, 8 /* PROPS */, ["modelValue", "label"]), _ctx.activated ? (openBlock(), createElementBlock("div", _hoisted_2$2, [!_ctx.isMobile ? (openBlock(), createElementBlock("div", _hoisted_3$1, [createVNode(_component_OrCheckboxV3, {
    modelValue: _ctx.state.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.state.visible = $event),
    label: _ctx.t('serviceDropdown.Visible')
  }, null, 8 /* PROPS */, ["modelValue", "label"]), createVNode(_component_OrCheckboxV3, {
    modelValue: _ctx.state.hiddenOnAccount,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.state.hiddenOnAccount = $event),
    label: _ctx.t('serviceDropdown.Hidden from account')
  }, null, 8 /* PROPS */, ["modelValue", "label"]), _ctx.isEnvManager ? (openBlock(), createBlock(_component_OrCheckboxV3, {
    key: 0,
    modelValue: _ctx.state.hiddenOnEnvironment,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.state.hiddenOnEnvironment = $event),
    label: _ctx.t('serviceDropdown.Hidden from environment')
  }, null, 8 /* PROPS */, ["modelValue", "label"])) : createCommentVNode("v-if", true)])) : (openBlock(), createBlock(_component_OrFilterV3, {
    key: 1,
    ref: "filterRef",
    "trigger-props": _ctx.filterTriggerProps,
    onApply: _cache[7] || (_cache[7] = $event => _ctx.handleApply()),
    onReset: _cache[8] || (_cache[8] = $event => _ctx.handleReset())
  }, {
    default: withCtx(() => [createElementVNode("div", _hoisted_4$1, [createVNode(_component_OrCheckboxV3, {
      modelValue: _ctx.mobileState.visible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.mobileState.visible = $event),
      class: "p-[10px]",
      label: _ctx.t('serviceDropdown.Visible')
    }, null, 8 /* PROPS */, ["modelValue", "label"]), createVNode(_component_OrCheckboxV3, {
      modelValue: _ctx.mobileState.hiddenOnAccount,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.mobileState.hiddenOnAccount = $event),
      class: "p-[10px]",
      label: _ctx.t('serviceDropdown.Hidden from account')
    }, null, 8 /* PROPS */, ["modelValue", "label"]), _ctx.isEnvManager ? (openBlock(), createBlock(_component_OrCheckboxV3, {
      key: 0,
      modelValue: _ctx.mobileState.hiddenOnEnvironment,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.mobileState.hiddenOnEnvironment = $event),
      class: "p-[10px]",
      label: _ctx.t('serviceDropdown.Hidden from environment')
    }, null, 8 /* PROPS */, ["modelValue", "label"])) : createCommentVNode("v-if", true)])]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["trigger-props"]))])) : createCommentVNode("v-if", true)]);
}

script$2.render = render$2;
script$2.__file = "src/components/ServiceNavigationDropdown/ServiceNavigationDropdownEdit.vue";

var script$1 = defineComponent({
  name: 'ServiceNavigationDropdownPopoverContent',
  components: {
    OrInputV3,
    OrEmptyStateV3,
    ServiceNavigationDropdownPopoverItem: script$5,
    ServiceNavigationDropdownPopoverItemSkeleton: script$4,
    ServiceNavigationDropdownIdwSection: script$3,
    ServiceNavigationDropdownEdit: script$2
  },
  props: {
    dropdownItems: {
      type: Array,
      default: () => []
    },
    favoritesServices: {
      type: Array,
      default: () => []
    },
    currentServiceId: {
      type: String,
      default: ''
    },
    idwInfo: {
      type: Object,
      default: () => undefined
    },
    trigger: {
      type: Object,
      default: null
    },
    userRole: {
      type: String,
      required: true
    }
  },
  emits: ['toggleFavorite', 'delete', 'hideFromAccount', 'hideFromEnvironment', 'revealOnAccount', 'revealOnEnvironment'],
  setup(props) {
    const root = ref();
    const search = ref('');
    const filterState = ref({
      hiddenOnEnvironment: false,
      hiddenOnAccount: false,
      visible: false
    });
    const isEditing = ref(false);
    const isEditingAvailable = computed(() => {
      return props.userRole && [UserRoles.admin, UserRoles.superAdmin].includes(props.userRole);
    });
    const {
      t
    } = useI18n();
    const {
      isMobile
    } = useResponsive();
    const isLoading = computed(() => {
      return props.dropdownItems.length === 0;
    });
    const isFilterApplied = computed(() => {
      return filterState.value.hiddenOnAccount || filterState.value.hiddenOnEnvironment || filterState.value.visible;
    });
    const skeletonsCount = computed(() => {
      return isMobile.value ? 4 : 10;
    });
    const filteredItems = computed(() => {
      return props.dropdownItems.filter(item => {
        if (item.hiddenFromEnvironment && props.userRole !== UserRoles.superAdmin) {
          return false;
        }
        if (isFilterApplied.value && isEditing.value) {
          if (filterState.value.visible && !item.hiddenFromAccount && !item.hiddenFromEnvironment) {
            return true;
          } else if (filterState.value.hiddenOnAccount && item.hiddenFromAccount) {
            return true;
          } else if (filterState.value.hiddenOnEnvironment && item.hiddenFromEnvironment) {
            return true;
          }
          return false;
        } else {
          if ((item.hiddenFromAccount || item.hiddenFromEnvironment) && !isEditing.value) {
            return false;
          }
        }
        return true;
      }).filter(item => t(item.label).toLowerCase().includes((search.value || '').toLowerCase())).sort((i1, i2) => i1.order - i2.order).sort((i1, i2) => {
        var _a, _b;
        return Number((_a = props === null || props === void 0 ? void 0 : props.favoritesServices) === null || _a === void 0 ? void 0 : _a.includes(i2.id)) - Number((_b = props === null || props === void 0 ? void 0 : props.favoritesServices) === null || _b === void 0 ? void 0 : _b.includes(i1.id));
      });
    });
    function handleUpdateFilterState(state) {
      filterState.value = state;
    }
    onMounted(() => {
      if (root.value) {
        root.value.style['min-height'] = `${root.value.clientHeight}px`;
      }
    });
    return {
      root,
      isFilterApplied,
      filterState,
      filteredItems,
      skeletonsCount,
      handleUpdateFilterState,
      isLoading,
      isMobile,
      isEditing,
      isEditingAvailable,
      search,
      t
    };
  }
});

const _hoisted_1$1 = {
  ref: "root",
  class: "layout-column h-full w-full max-w-[1184px] overflow-hidden py-sm+ md:h-auto md:py-lg"
};
const _hoisted_2$1 = {
  key: 1,
  class: "typography-headline-3 px-lg py-sm+"
};
const _hoisted_3 = {
  key: 2,
  class: "layout-column gap-md px-lg pb-lg md:px-sm"
};
const _hoisted_4 = {
  key: 3,
  class: "layout-column px-lg pb-md md:px-sm"
};
const _hoisted_5 = {
  key: 0,
  class: "mt-sm+ h-[1px] w-full bg-outline-variant md:mb-sm md:mt-lg dark:bg-outline-variant-dark"
};
const _hoisted_6 = {
  key: 4,
  class: "layout-column h-full grow items-center justify-center"
};
const _hoisted_7 = {
  class: "layout-column"
};
const _hoisted_8 = {
  class: "grid grid-cols-1 gap-0 overflow-auto md:grid-cols-4 md:gap-sm lg:grid-cols-5"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ServiceNavigationDropdownIdwSection = resolveComponent("ServiceNavigationDropdownIdwSection");
  const _component_OrInputV3 = resolveComponent("OrInputV3");
  const _component_ServiceNavigationDropdownEdit = resolveComponent("ServiceNavigationDropdownEdit");
  const _component_OrEmptyStateV3 = resolveComponent("OrEmptyStateV3");
  const _component_ServiceNavigationDropdownPopoverItem = resolveComponent("ServiceNavigationDropdownPopoverItem");
  const _component_ServiceNavigationDropdownPopoverItemSkeleton = resolveComponent("ServiceNavigationDropdownPopoverItemSkeleton");
  return openBlock(), createElementBlock("div", _hoisted_1$1, [_ctx.idwInfo ? (openBlock(), createBlock(_component_ServiceNavigationDropdownIdwSection, {
    key: 0,
    "idw-info": _ctx.idwInfo
  }, null, 8 /* PROPS */, ["idw-info"])) : createCommentVNode("v-if", true), _ctx.isMobile ? (openBlock(), createElementBlock("div", _hoisted_2$1, toDisplayString(_ctx.t('Services')), 1 /* TEXT */)) : createCommentVNode("v-if", true), _ctx.dropdownItems.length > 10 ? (openBlock(), createElementBlock("div", _hoisted_3, [createVNode(_component_OrInputV3, {
    modelValue: _ctx.search,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.search = $event),
    placeholder: "Search",
    type: "search"
  }, null, 8 /* PROPS */, ["modelValue"])])) : createCommentVNode("v-if", true), _ctx.isEditingAvailable ? (openBlock(), createElementBlock("div", _hoisted_4, [createVNode(_component_ServiceNavigationDropdownEdit, {
    "is-editing": _ctx.isEditing,
    "user-role": _ctx.userRole,
    "onUpdate:isEditing": _cache[1] || (_cache[1] = event => _ctx.isEditing = event),
    "onUpdate:filterState": _ctx.handleUpdateFilterState
  }, null, 8 /* PROPS */, ["is-editing", "user-role", "onUpdate:filterState"]), _ctx.isEditing ? (openBlock(), createElementBlock("div", _hoisted_5)) : createCommentVNode("v-if", true)])) : createCommentVNode("v-if", true), (_ctx.search || _ctx.isFilterApplied) && _ctx.filteredItems.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_6, [createVNode(_component_OrEmptyStateV3, {
    heading: _ctx.t('serviceDropdown.No results')
  }, {
    default: withCtx(() => [createElementVNode("div", _hoisted_7, [createElementVNode("span", null, toDisplayString(_ctx.t('serviceDropdown.no_found_first_line')), 1 /* TEXT */), createElementVNode("span", null, toDisplayString(_ctx.t('serviceDropdown.not_found_second_line')), 1 /* TEXT */)])]),

    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["heading"])])) : createCommentVNode("v-if", true), createElementVNode("div", _hoisted_8, [!_ctx.isLoading ? (openBlock(true), createElementBlock(Fragment, {
    key: 0
  }, renderList(_ctx.filteredItems, item => {
    return openBlock(), createBlock(_component_ServiceNavigationDropdownPopoverItem, {
      key: item.id,
      item: item,
      favorite: Boolean(_ctx.favoritesServices && _ctx.favoritesServices.includes(item.id)),
      "current-service-id": _ctx.currentServiceId,
      "is-editing": _ctx.isEditing,
      "user-role": _ctx.userRole,
      onToggleFavorite: _cache[2] || (_cache[2] = $event => _ctx.$emit('toggleFavorite', $event)),
      onDelete: _cache[3] || (_cache[3] = $event => _ctx.$emit('delete', $event)),
      onHideFromAccount: _cache[4] || (_cache[4] = $event => _ctx.$emit('hideFromAccount', $event)),
      onHideFromEnvironment: _cache[5] || (_cache[5] = $event => _ctx.$emit('hideFromEnvironment', $event)),
      onRevealOnAccount: _cache[6] || (_cache[6] = $event => _ctx.$emit('revealOnAccount', $event)),
      onRevealOnEnvironment: _cache[7] || (_cache[7] = $event => _ctx.$emit('revealOnEnvironment', $event))
    }, null, 8 /* PROPS */, ["item", "favorite", "current-service-id", "is-editing", "user-role"]);
  }), 128 /* KEYED_FRAGMENT */)) : (openBlock(true), createElementBlock(Fragment, {
    key: 1
  }, renderList(_ctx.skeletonsCount, index => {
    return openBlock(), createBlock(_component_ServiceNavigationDropdownPopoverItemSkeleton, {
      key: index
    });
  }), 128 /* KEYED_FRAGMENT */))])], 512 /* NEED_PATCH */);
}

script$1.render = render$1;
script$1.__file = "src/components/ServiceNavigationDropdown/ServiceNavigationDropdownPopoverContent.vue";

const IDW_SERVICE_KEY = 'idw-manager-ui';

var script = defineComponent({
  name: 'ServiceNavigationDropdown',
  components: {
    OrIconV3,
    OrButtonV3,
    OrPopoverV3,
    OrDrawerV3,
    ServiceNavigationDropdownPopoverContent: script$1
  },
  props: {
    isIdwAccount: {
      type: Boolean,
      default: () => false
    },
    idwInfo: {
      type: Object,
      default: () => undefined
    },
    dropdownItems: {
      type: Array,
      default: () => []
    },
    projectLabel: {
      type: String,
      default: ''
    },
    projectId: {
      type: String,
      default: ''
    },
    favoritesServices: {
      type: Array,
      default: () => []
    },
    userRole: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['toggleFavorite', 'delete', 'hideFromAccount', 'hideFromEnvironment', 'revealOnAccount', 'revealOnEnvironment'],
  setup(props) {
    const {
      t
    } = useI18n();
    const isMounted = useMounted();
    const dropdownButtonRef = ref();
    const popoverContainerRef = ref();
    const {
      isMobile,
      isDesktop
    } = useResponsive();
    const [isOpen, toggle] = useToggle(false);
    const {
      top
    } = useElementBounding(popoverContainerRef);
    const maxPopoverContainerHeight = computed(() => {
      return `calc(100vh - ${top.value}px)`;
    });
    const filteredDropdownItems = computed(() => {
      return props.isIdwAccount ? props.dropdownItems.filter(i => i.id !== IDW_SERVICE_KEY) : props.dropdownItems;
    });
    const idwInfoExtended = computed(() => {
      var _a;
      const serviceLink = (_a = props.dropdownItems.find(i => i.id === IDW_SERVICE_KEY)) === null || _a === void 0 ? void 0 : _a.url;
      return props.idwInfo ? {
        ...props.idwInfo,
        serviceLink
      } : undefined;
    });
    const projectLabelTranslated = computed(() => {
      var _a;
      return isMounted.value ? props.isIdwAccount && props.idwInfo && props.projectId === IDW_SERVICE_KEY ? (_a = props.idwInfo) === null || _a === void 0 ? void 0 : _a.name : t(props.projectLabel) : '';
    });
    return {
      t,
      toggle,
      isOpen,
      isMobile,
      isDesktop,
      popoverContainerRef,
      dropdownButtonRef,
      maxPopoverContainerHeight,
      filteredDropdownItems,
      idwInfoExtended,
      projectLabelTranslated
    };
  }
});

const _hoisted_1 = {
  "data-test": "service-dropdown",
  class: "flex overflow-hidden sm:min-w-fit"
};
const _hoisted_2 = {
  class: "typography-headline-2 truncate",
  "data-test": "service-dropdown-active-service-label"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIconV3 = resolveComponent("OrIconV3");
  const _component_OrButtonV3 = resolveComponent("OrButtonV3");
  const _component_ServiceNavigationDropdownPopoverContent = resolveComponent("ServiceNavigationDropdownPopoverContent");
  const _component_OrPopoverV3 = resolveComponent("OrPopoverV3");
  const _component_OrDrawerV3 = resolveComponent("OrDrawerV3");
  return openBlock(), createElementBlock("div", _hoisted_1, [createVNode(_component_OrButtonV3, {
    ref: "dropdownButtonRef",
    variant: "text",
    color: "inherit",
    class: "!px-none !text-white",
    "data-test": "service-dropdown-btn",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.toggle(!_ctx.isOpen))
  }, {
    default: withCtx(() => [createElementVNode("div", _hoisted_2, toDisplayString(_ctx.projectLabelTranslated), 1 /* TEXT */), createVNode(_component_OrIconV3, {
      icon: _ctx.isOpen ? 'expand_less' : 'expand_more'
    }, null, 8 /* PROPS */, ["icon"])]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */), _ctx.isOpen && _ctx.isDesktop ? (openBlock(), createBlock(_component_OrPopoverV3, {
    key: 0,
    "is-open": _ctx.isOpen,
    trigger: _ctx.dropdownButtonRef && _ctx.dropdownButtonRef.root,
    offset: 4,
    "disable-default-styles": "",
    onClose: _cache[7] || (_cache[7] = $event => _ctx.toggle(false))
  }, {
    default: withCtx(() => [createElementVNode("div", {
      ref: "popoverContainerRef",
      class: "layout-column theme-foreground-default theme-background-base w-screen items-center rounded-b-lg shadow-contextual dark:theme-foreground-default-dark dark:theme-background-default-dark dark:shadow-contextual-dark",
      style: normalizeStyle({
        maxHeight: _ctx.maxPopoverContainerHeight
      })
    }, [createVNode(_component_ServiceNavigationDropdownPopoverContent, {
      trigger: _ctx.dropdownButtonRef && _ctx.dropdownButtonRef.root,
      "dropdown-items": _ctx.filteredDropdownItems,
      "favorites-services": _ctx.favoritesServices,
      "idw-info": _ctx.idwInfoExtended,
      "current-service-id": _ctx.projectId,
      "user-role": _ctx.userRole,
      "data-test": "sn-dropdown",
      onToggleFavorite: _cache[1] || (_cache[1] = $event => _ctx.$emit('toggleFavorite', $event)),
      onDelete: _cache[2] || (_cache[2] = $event => _ctx.$emit('delete', $event)),
      onHideFromAccount: _cache[3] || (_cache[3] = $event => _ctx.$emit('hideFromAccount', $event)),
      onHideFromEnvironment: _cache[4] || (_cache[4] = $event => _ctx.$emit('hideFromEnvironment', $event)),
      onRevealOnAccount: _cache[5] || (_cache[5] = $event => _ctx.$emit('revealOnAccount', $event)),
      onRevealOnEnvironment: _cache[6] || (_cache[6] = $event => _ctx.$emit('revealOnEnvironment', $event))
    }, null, 8 /* PROPS */, ["trigger", "dropdown-items", "favorites-services", "idw-info", "current-service-id", "user-role"])], 4 /* STYLE */)]),

    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-open", "trigger"])) : createCommentVNode("v-if", true), _ctx.isOpen && _ctx.isMobile ? (openBlock(), createBlock(_component_OrDrawerV3, {
    key: 1,
    "is-open": _ctx.isOpen,
    padding: false,
    class: "w-full !p-0",
    onClose: _cache[14] || (_cache[14] = $event => _ctx.toggle(false))
  }, {
    default: withCtx(() => [createVNode(_component_ServiceNavigationDropdownPopoverContent, {
      trigger: _ctx.dropdownButtonRef && _ctx.dropdownButtonRef.root,
      "dropdown-items": _ctx.filteredDropdownItems,
      "favorites-services": _ctx.favoritesServices,
      "idw-info": _ctx.idwInfoExtended,
      "current-service-id": _ctx.projectId,
      "user-role": _ctx.userRole,
      "data-test": "sn-dropdown",
      onToggleFavorite: _cache[8] || (_cache[8] = $event => _ctx.$emit('toggleFavorite', $event)),
      onDelete: _cache[9] || (_cache[9] = $event => _ctx.$emit('delete', $event)),
      onHideFromAccount: _cache[10] || (_cache[10] = $event => _ctx.$emit('hideFromAccount', $event)),
      onHideFromEnvironment: _cache[11] || (_cache[11] = $event => _ctx.$emit('hideFromEnvironment', $event)),
      onRevealOnAccount: _cache[12] || (_cache[12] = $event => _ctx.$emit('revealOnAccount', $event)),
      onRevealOnEnvironment: _cache[13] || (_cache[13] = $event => _ctx.$emit('revealOnEnvironment', $event))
    }, null, 8 /* PROPS */, ["trigger", "dropdown-items", "favorites-services", "idw-info", "current-service-id", "user-role"])]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-open"])) : createCommentVNode("v-if", true)]);
}

script.render = render;
script.__file = "src/components/ServiceNavigationDropdown/ServiceNavigationDropdown.vue";

export { UserRoles as U, script as s };
